export default "__VITE_ASSET__LESFDSmu__"